<template>
  <div id="educationViewItemComp" @click="$emit('click')">
    <van-image class="img" :src="item.defaultImage" fit="cover"></van-image>
    <div class="content">
      <div class="title">
        <div class="main text-ellipsis">{{item.title}}</div>
        <div class="sub omit">{{item.digest}}</div>
      </div>
      <div class="date">{{item.createTime | formatDate('yyyy-MM-dd hh:mm')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EducationViewItemComp',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="less" scoped>
#educationViewItemComp {
  width: 100%;
  padding: 30px 28px;
  display: flex;
  align-items: center;
  .img {
    width: 244px;
    height: 162px;
    border-radius: 8px;
    overflow: hidden;
  }
  .content {
    flex: 1;
    width: 0;
    margin-left: 20px;
    height: 162px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      width: 100%;
      .main {
        font-size: 28px;
        color: #333444;
      }
      .sub {
        font-size: 22px;
        font-weight: 500;
        color: #999AAA;
      }
    }
    .date {
      font-size: 22px;
      font-weight: 500;
      color: #999AAA;
    }
  }
}
</style>